import useSWR from "swr";
import { query } from "./client";

export const useQuery = ([url, params = {}], options = {}) => {
  const { data, error, isLoading, mutate } = useSWR(
    [url, params],
    ([url, params]) =>
      query.get(url, { params }).then((response) => response.data),
    options
  );

  return {
    data,
    loading: isLoading,
    error,
    mutate,
  };
};
